import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { stringify } from 'qs';
import { map, Observable } from 'rxjs';
import { extractStrapiData } from '../../helpers';
import {
  BatteryRange,
  StrapiPageResponse,
  StrapiQueryParams,
} from '../../models';

@Injectable({
  providedIn: 'root',
})
export class BatteryRangeService {
  private readonly http = inject(HttpClient);

  private readonly url = '/api/battery-ranges/getAll';
  private readonly defaultQueryParams: StrapiQueryParams = {};

  getAll(queryParams?: StrapiQueryParams): Observable<BatteryRange[]> {
    const queryString = this.buildQueryString(queryParams);
    const targetUrl = queryString ? `${this.url}?${queryString}` : this.url;

    return this.http
      .get<StrapiPageResponse<BatteryRange>>(targetUrl)
      .pipe(map((response) => extractStrapiData(response)));
  }

  private buildQueryString(queryParams?: StrapiQueryParams): string {
    return stringify(
      {
        ...this.defaultQueryParams,
        ...queryParams,
      },
      { encodeValuesOnly: true },
    );
  }
}
